/**
 * Módulo de alertas y casos (#42).
 *
 * Sin `minimumRole`: leer la bandeja es exactamente lo que un `viewer` tiene
 * que poder hacer —es el rol del equipo de calidad, que mira y no toca— y así
 * lo declara `MINIMUM_ROLE` en `services/api/routers/alerts.py`. Operarla
 * (asignar, cerrar, anotar) exige `analyst` y eso se resuelve dentro del
 * módulo escondiendo lo que sólo puede terminar en 403.
 *
 * El caso seleccionado va en la URL (`/alerts/1234`) y no en el estado del
 * componente: un investigador pega el enlace del caso en el ticket, y con la
 * selección en memoria ese enlace abriría la bandeja vacía.
 */
import type { ModuleRoutes } from '../module';
import { AlertsInboxPage } from './AlertsInboxPage';

export const moduleRoutes: ModuleRoutes = {
  moduleId: 'alerts',
  routes: [
    { path: '', element: <AlertsInboxPage /> },
    { path: ':alertId', element: <AlertsInboxPage /> },
  ],
};
